import { BAlert } from './alert';
import { pluginFactory } from '../../utils/plugins';
var AlertPlugin =
/*#__PURE__*/
pluginFactory({
  components: {
    BAlert: BAlert
  }
});
export { AlertPlugin, BAlert };


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/esm/components/alert/index.js
// module id = ./node_modules/bootstrap-vue/esm/components/alert/index.js
// module chunks = 1